/**
 * Chama `callback` depois do primeiro quadro com conteúdo da página (FCP), ou
 * em `maxWaitMs` se ele não vier (aba aberta em segundo plano não pinta) ou se
 * o navegador não expõe o paint timing. Devolve o cancelamento, para usar
 * direto como retorno de `useEffect`.
 */
export function afterFirstContentfulPaint(
  callback: () => void,
  maxWaitMs = 5000
): () => void {
  const supportsPaint =
    typeof PerformanceObserver !== "undefined" &&
    (PerformanceObserver.supportedEntryTypes ?? []).includes("paint");
  if (!supportsPaint) {
    callback();
    return () => undefined;
  }

  let done = false;
  const stop = () => {
    done = true;
    observer.disconnect();
    window.clearTimeout(timer);
  };
  const finish = () => {
    if (done) return;
    stop();
    callback();
  };

  const observer = new PerformanceObserver((list) => {
    if (list.getEntriesByName("first-contentful-paint").length > 0) finish();
  });
  const timer = window.setTimeout(finish, maxWaitMs);
  // `buffered` entrega também o FCP que já aconteceu antes de observar (a
  // entrega é assíncrona, depois de `observer` e `timer` existirem).
  observer.observe({ type: "paint", buffered: true });

  return stop;
}
